window.waitForStorefrontToken = function(timeoutMs = 3000) {
    return new Promise((resolve, reject) => {
        if (window.storefrontAccessToken) {
            resolve(window.storefrontAccessToken);
            return;
        }

        const deadline = Date.now() + timeoutMs;
        const interval = setInterval(() => {
            if (window.storefrontAccessToken) {
                clearInterval(interval);
                resolve(window.storefrontAccessToken);
            } else if (Date.now() >= deadline) {
                clearInterval(interval);
                reject(new Error('Storefront token not available'));
            }
        }, 50);
    });
};
